<template>
  <v-expansion-panels
    :value="panel"
    @change="$emit('update_panel', $event)"
    accordion
    class="accordion"
  >

    <!-- paramter_panel[0]: title -->
    <v-expansion-panel v-if="visible_panel.indexOf('title') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.common.title") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                {{ make_title('title') }}
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-text-field
          :label="$t('message.common.title')"
          v-model="parameters.title"
          :rules="[
            v => (v && v.length <= 80) || $t('message.common.over_text', { length: 80 })
          ]"
          counter="80"
        >
        </v-text-field>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[1]: lang_pair -->
    <v-expansion-panel v-if="visible_panel.indexOf('lang_pair') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.common.language") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                {{ $t("message.common.lang_" + parameters.source_lang) }}
                <template v-if="command_type == 'translate'">
                  &rarr;
                  {{ $t("message.common.lang_" + parameters.target_lang) }}
                </template>
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <LangPairSelect
          :lang_pair="lang_pair"
          v-on:update_lang_pair="update_lang_pair"
          :lang_pairs="$store.getters.lang_pairs['translatable']"
          :display_type="command_type == 'translate' ? 'source_target' : 'source'"
        ></LangPairSelect>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[2]: field/model -->
    <v-expansion-panel v-if="visible_panel.indexOf('field_model') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.common.translate_engine") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                <template v-if="field_tab === 'field' && selected_field.length > 0">
                  {{ $t("message.common.general") }}:&nbsp;
                  {{ selected_field.length > 0 ? (field_property(selected_field[0], "name") + "(" + selected_field[0] + ")") : "" }}
                </template>
                <template v-else-if="field_tab === 'model' && selected_model.length > 0">
                  {{ $t("message.common.model") }}:&nbsp;
                  {{ selected_model.length > 0 ? (selected_model[0].name ? selected_model[0].name.replace(/\([A-Z]\d{5,8}\)/g, "") + "(" + selected_model[0].mid + ")" : selected_model[0].mid) : "" }}
                </template>
                <template v-else>
                  <span class="text--secondary">{{ $t("message.common.select_text") }}</span>
                </template>
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content eager>
        <v-tabs
          background-color="primary"
          dark
          v-model="field_tab"
          @change="reset_field_tab"
        >
          <v-tab href="#field">
            {{ $t("message.common.general") }}
          </v-tab>
          <template v-if="$store.getters.user && ['the-reading'].indexOf($store.getters.user.domain) < 0">
            <v-tab href="#model">
              {{ $t("message.common.model") }}
            </v-tab>
          </template>

          <v-tabs-items v-model="field_tab">
            <v-tab-item value="field">
              <v-card>
                <v-card-text>
                  <div class="d-flex flex-wrap pa-3">
                    <div>
                      {{ $t("message.common.selecting_field") }}：
                    </div>
                    <div>
                      {{ selected_field.length > 0 ? field_property(selected_field[0], "name") + " (" + selected_field[0] + ")" : "" }}
                    </div>
                  </div>
                  <FieldSelect
                    ref="field_select"
                    :source_lang="parameters.source_lang"
                    :target_lang="parameters.target_lang"
                    type="translatable"
                    :selected_field="selected_field"
                    v-on:update_selected_field="selected_field = $event"
                    class="body-2 mt-1"
                  ></FieldSelect>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <template v-if="$store.getters.user && ['the-reading'].indexOf($store.getters.user.domain) < 0">
              <v-tab-item value="model">
                <ModelSelect
                  ref="model_select"
                  :source_lang="parameters.source_lang"
                  :target_lang="parameters.target_lang"
                  :multiple="false"
                  :select_one="true"
                  :max_select="1"
                  :show_select="true"
                  :selected_model="selected_model"
                  :initital_mid="selected_model.length > 0 ? selected_model[0].mid : ''"
                  v-on:update_model_select="selected_model = $event"
                  :mode="mode"
                  :file_remarks="file_remarks"
                ></ModelSelect>
              </v-tab-item>
            </template>
          </v-tabs-items>
        </v-tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[3]: corpuses -->
    <v-expansion-panel v-if="visible_panel.indexOf('corpuses') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.translate.corpuses") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                <template v-if="selected_corpuses.length > 0">
                  <template v-for="(corpus, index) in selected_corpuses">
                    <template v-if="index > 0">
                      ,&nbsp;
                    </template>
                    {{ corpus.name.replace(/\([A-Z]\d{5,8}\)/g, "") }}({{ corpus.cid }})
                  </template>
                </template>
                <template v-else>
                  <span class="text--secondary">{{ $t("message.common.not_use") }}</span>
                </template>
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <PriorityCorpusSelect
          ref="corpuses_select"
          :selected_corpus="selected_corpuses"
          :lang_pairs="[parameters.source_lang, parameters.target_lang]"
          v-on:update_corpuses_select="selected_corpuses = $event"
          :mode="mode"
          :multiple="true"
          :select_one="false"
          :max_select="3"
          :upload_refer="upload_refer"
        ></PriorityCorpusSelect>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[4]: terms -->
    <v-expansion-panel v-if="visible_panel.indexOf('terms') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.translate.terms") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                <template v-if="selected_terms.length > 0">
                  {{ $t("message.translate.term_case_sensitive") }}=
                  {{ $t("message.common." + (parameters.term_case_sensitive ? "yes" : "no")) }}<br />
                  {{ $t("message.translate.terms") }}=
                  <template v-for="(term, index) in selected_terms">
                    <template v-if="index > 0">
                      ,&nbsp;
                    </template>
                    {{ term.name.replace(/\([A-Z]\d{5,8}\)/g, "") }}({{ term.yid }})
                  </template>
                </template>
                <template v-else>
                  <span class="text--secondary">{{ $t("message.common.not_use") }}</span>
                </template>
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-checkbox
          :label="$t('message.translate.term_case_sensitive')"
          v-model="parameters.term_case_sensitive"
        />
        <PriorityTermSelect
          ref="terms_select"
          :selected_term="selected_terms"
          :lang_pairs="[parameters.source_lang, parameters.target_lang]"
          v-on:update_terms_select="selected_terms = $event"
          :mode="mode"
          :multiple="true"
          :select_one="false"
          :max_select="3"
          :upload_refer="upload_refer"
        ></PriorityTermSelect>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[5]: detail -->
    <v-expansion-panel v-if="visible_panel.indexOf('detail') !== -1
      && (tag_available(is_xml) || style_option_ja_available || score_threshold_available || bullet_feature_available)">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.translate.detail") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                <template v-if="tag_available(is_xml) && tag_types.length > 1">
                  {{ $t('message.translate.tag_type') }}={{ $t('message.translate.' + parameters.detail.tag_option.tag_type) }}
                  <template v-if="style_option_ja_available || score_threshold_available || bullet_feature_available">
                    <br />
                  </template>
                </template>
                <template v-if="style_option_ja_available">
                  {{ $t('message.translate.character_style') }}={{ $t('message.translate.' + parameters.detail.style_option_ja.character_style) }},&nbsp;
                  {{ $t('message.translate.parenthesis_style') }}={{ $t('message.translate.' + parameters.detail.style_option_ja.parenthesis_style) }}&nbsp;
                  {{ $t('message.translate.sentence_style') }}={{ $t('message.translate.' + parameters.detail.style_option_ja.sentence_style) }}
                  <template v-if="score_threshold_available || bullet_feature_available">
                    <br />
                  </template>
                </template>
                <template v-if="score_threshold_available">
                  {{ $t('message.translate.custom_model_similarity') }}={{ parameters.detail.score_threshold.custom_model }}
                  <template v-if="bullet_feature_available">
                    <br />
                  </template>
                </template>
                <template v-if="bullet_feature_available">
                  {{ $t('message.translate.bullet_feature') }}=
                  {{ $t('message.common.' + (parameters.detail.bullet_option.bullet_feature ? 'yes' : 'no')) }}
                </template>
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <!-- detail_panel[0]: tag_option -->
        <template v-if="tag_available(is_xml) && tag_types.length > 1">
          <!-- tag_type -->
          <v-select
            :items="tag_types"
            item-text="label"
            item-value="value"
            v-model="parameters.detail.tag_option.tag_type"
          >
            <template v-slot:item="props">
              {{ $t('message.translate.' + props.item.label) }}
            </template>
            <template v-slot:selection="props">
              {{ $t('message.translate.' + props.item.label) }}
            </template>
            <template v-slot:label>
              {{ $t('message.translate.tag_type') }}
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon class="mb-1" size="16" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t('message.translate.tag_description') }}</span>
              </v-tooltip>
            </template>
          </v-select>
        </template>

        <!-- detail_panel[1]: style_option_ja -->
        <template v-if="style_option_ja_available">
          <v-subheader class="pl-0">
            {{ $t("message.translate.style_option_ja") }}
          </v-subheader>

          <!-- character_style -->
          <v-select
            :label="$t('message.translate.character_style')"
            :items="character_styles"
            item-text="label"
            item-value="value"
            v-model="parameters.detail.style_option_ja.character_style"
          >
            <template v-slot:item="props">
              {{ $t('message.translate.' + props.item.label) }}
            </template>
            <template v-slot:selection="props">
              {{ $t('message.translate.' + props.item.label) }}
            </template>
          </v-select>
          <!-- parenthesis_style -->
          <v-select
            :label="$t('message.translate.parenthesis_style')"
            :items="character_styles"
            item-text="label"
            item-value="value"
            v-model="parameters.detail.style_option_ja.parenthesis_style"
          >
            <template v-slot:item="props">
              {{ $t('message.translate.' + props.item.label) }}
            </template>
            <template v-slot:selection="props">
              {{ $t('message.translate.' + props.item.label) }}
            </template>
          </v-select>
          <!-- sentence_styles -->
          <v-select
            :label="$t('message.translate.sentence_style')"
            :items="sentence_styles"
            item-text="label"
            item-value="value"
            v-model="parameters.detail.style_option_ja.sentence_style"
          >
            <template v-slot:item="props">
              {{ $t('message.translate.' + props.item.label) }}
            </template>
            <template v-slot:selection="props">
              {{ $t('message.translate.' + props.item.label) }}
            </template>
          </v-select>
        </template>

        <!-- detail_panel[2]: score_threshold -->
        <template v-if="score_threshold_available">
          <v-subheader class="pl-0">
            {{ $t("message.translate.score_threshold") }}
          </v-subheader>

          <!-- custom_model -->
          <v-slider
            :label="$t('message.translate.custom_model_similarity')"
            v-model="parameters.detail.score_threshold.custom_model"
            thumb-label="always"
          ></v-slider>
        </template>

        <!-- detail_panel[3]: bullet_option -->
        <template v-if="bullet_feature_available">
          <!-- bullet_feature -->
          <v-switch
            :label="$t('message.translate.bullet_feature')"
            v-model="parameters.detail.bullet_option.bullet_feature"
          >
            <template v-slot:label>
              {{ $t("message.translate.bullet_feature") }}
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon class="mb-1" size="16" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span v-html="$t('message.translate.bullet_feature_desc_' + $store.getters.domain)"></span>
              </v-tooltip>
            </template>
          </v-switch>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import LangPairSelect from '../components/LangPairSelect';
import FieldSelect from '../components/FieldSelect';
import ModelSelect from '../components/ModelSelect';
import PriorityCorpusSelect from '../components/PriorityCorpusSelect';
import PriorityTermSelect from '../components/PriorityTermSelect';
import { http_error } from "../js/http_error";
import _cloneDeep from "lodash/cloneDeep";
import isEqual from 'lodash/isEqual';

export default {
  name: 'translation_preset_parameter',
  components: {
    LangPairSelect,
    FieldSelect,
    ModelSelect,
    PriorityCorpusSelect,
    PriorityTermSelect
  },
  mixins: [http_error],
  props: {
    panel: Number,
    visible_panel: Array,
    mode: String,
    upload_refer: String,
    initial_parameters: Object,
    is_xml: Boolean,
    file_remarks: {
      type: Object,
      default: null
    },
    command_type: String
  },
  data: function(){
    return {
      module_id: "77",

      // common
      paramter_panel: 0,
      parameters: {
        title: "",
        source_lang: "en",
        target_lang: "ja",
        model_type: "field",
	      model: "L000001",
        corpuses: [],
        term_case_sensitive: false,
        terms: [],
        detail: {
          tag_option: {
            tag_type: "tag_type1",
          },
          style_option_ja: {
            character_style: "no_spec",
            parenthesis_style: "no_spec",
            sentence_style: "no_spec"
          },
          score_threshold: {
            custom_model: 0
          },
          bullet_option: {
            bullet_feature: true
          }
        }
      },

      // paramter_panel[1]: lang_pair
      source_lang_valid: true,
      target_lang_valid: true,

      // paramter_panel[2]: field/model
      field_tab: "field",
      //// field_tab[0]: field
      selected_field: [],
      //// field_tab[1]: model
      selected_model: [],

      // paramter_panel[3]: corpuses
      selected_corpuses: [],

      // paramter_panel[4]: terms
      selected_terms: [],

      // paramter_panel[5]: detail
      //// detail_panel[1]: style_option_ja
      character_styles: [
        {
          "label": "no_spec",
          "value": "no_spec"
        },
        {
          "label": "single_byte",
          "value": "single_byte"
        },
        {
          "label": "double_byte",
          "value": "double_byte"
        }
      ],
      sentence_styles: [
        {
          "label": "no_spec",
          "value": "no_spec"
        },
        {
          "label": "plain",
          "value": "plain"
        },
        {
          "label": "polite",
          "value": "polite"
        }
      ],
    }
  },
  mounted: function(){
    this.mounted(this.initial_parameters);
  },
  computed: {
   field_property: function() {
      return function(lid, property){
        var result = lid;
        var lang = this.$i18n.locale;
        if(!this.$store.getters.fields.translatable){
          return result;
        }else if(!this.$store.getters.fields.translatable[lang]){
          lang = "en";
        }
        var lang_pair = this.parameters.source_lang + "_" + this.parameters.target_lang;
        var lid_data = this.$store.getters.fields.translatable[lang][lang_pair];
        if(lid_data && lid_data[lid]){
          result = lid_data[lid][property];
        }
        return result;
      }.bind(this);
    },
    registable: function(){
      return this.parameters.title.length <= 80
        && this.parameters.source_lang !== ""
        && this.parameters.target_lang !== ""
        && (this.command_type === 'estimate'
        || (this.field_tab === 'field' && this.selected_field.length > 0 && this.field_property(this.selected_field[0], 'available'))
        || (this.field_tab === 'model' && this.selected_model.length > 0));
    },
    changable: function(){
      var detail = _cloneDeep(this.parameters.detail);
      if(!this.tag_available(true)){
        delete detail.tag_option.tag_type;
      }
      if(Object.keys(detail.tag_option).length === 0){
        delete detail.tag_option;
      }
      if(!this.style_option_ja_available){
        delete detail.style_option_ja.character_style;
        delete detail.style_option_ja.parenthesis_style;
        delete detail.style_option_ja.sentence_style;
      }
      if(Object.keys(detail.style_option_ja).length === 0){
        delete detail.style_option_ja;
      }
      if(!this.score_threshold_available){
        delete detail.score_threshold.custom_model;
      }
      if(Object.keys(detail.score_threshold).length === 0){
        delete detail.score_threshold;
      }
      if(!this.bullet_feature_available){
        delete detail.bullet_option.bullet_feature;
      }
      if(Object.keys(detail.bullet_option).length === 0){
        delete detail.bullet_option;
      }
      if(Object.keys(detail).length === 0){
        detail = {};
      }

      var result = this.initial_parameters
        && this.registable
        && ((this.visible_panel.indexOf('title') !== -1
            && this.initial_parameters.title !== this.parameters.title)
          || (this.visible_panel.indexOf('lang_pair') !== -1
            && (this.initial_parameters.source_lang !== this.parameters.source_lang
              || this.initial_parameters.target_lang !== this.parameters.target_lang))
          || (this.visible_panel.indexOf('field_model') !== -1
            && (this.initial_parameters.model_type !== this.field_tab
              || (this.field_tab === 'field'
                && this.selected_field.length > 0
                && this.selected_field[0] !== this.initial_parameters.model)
              || (this.$store.getters.domain === "t-3mt"
                && this.field_tab === 'model'
                && this.selected_model.length > 0
                && this.selected_model[0].mid !== this.initial_parameters.model)))
          || (this.$store.getters.domain === "t-3mt"
            && (this.visible_panel.indexOf('corpuses') !== -1
                  && !this.array_equal(this.initial_parameters.corpuses, this.selected_corpuses.map((x) => x.cid)))
              || (this.visible_panel.indexOf('terms') !== -1
                && (this.initial_parameters.term_case_sensitive !== this.parameters.term_case_sensitive
                  || !this.array_equal(this.initial_parameters.terms, this.selected_terms.map((x) => x.yid)))))
          || (this.visible_panel.indexOf('detail') !== -1
            && (!("detail" in this.initial_parameters)
            || !isEqual(this.initial_parameters.detail, detail))));
      return result;
    },
    lang_pair: {
      get: function () {
        return {
          source_lang: this.parameters.source_lang,
          target_lang: this.parameters.target_lang
        }
      },
      set: function(new_lang_pair){
        this.parameters.source_lang = new_lang_pair.source_lang;
        this.parameters.target_lang = new_lang_pair.target_lang;
      }
    },
    tag_available: function(){
      return function(is_xml){
        var is_lang_pair = false;
        switch(this.parameters.source_lang + this.parameters.target_lang){
          case "enja":
          case "jaen":
            is_lang_pair = true;
            break;
        }
        return is_xml;
      }
    },
    tag_types: function(){
      var tag_types = [];
      switch(this.parameters.source_lang + this.parameters.target_lang){
        case "jazh-CN":
        case "zh-CNja":
        case "jazh-TW":
        case "zh-TWja":
          tag_types = [
            {
              "label": "tag_type1",
              "value": "tag_type1"
            }
          ];
          if(this.field_tab === "field"
            || this.selected_model.length === 0
            || this.selected_model[0].engine !== "roz_r1"){
            tag_types.push({
              "label": "tag_type4",
              "value": "tag_type4"
            });
            if(["tag_type1", "tag_type4"].indexOf(this.parameters.detail.tag_option.tag_type) < 0){
              this.parameters.detail.tag_option.tag_type = "tag_type1";
            }
          }else{
            if(["tag_type1"].indexOf(this.parameters.detail.tag_option.tag_type) < 0){
              this.parameters.detail.tag_option.tag_type = "tag_type1";
            }
          }
          break;
        default:
          tag_types = [
            {
              "label": "tag_type1",
              "value": "tag_type1"
            },
            {
              "label": "tag_type4",
              "value": "tag_type4"
            }
          ];
          if(["tag_type1", "tag_type4"].indexOf(this.parameters.detail.tag_option.tag_type) < 0){
            this.parameters.detail.tag_option.tag_type = "tag_type1";
          }
          break;
      }
      return tag_types;
    },
    style_option_ja_available: function(){
      return this.parameters.target_lang === "ja";
    },
    score_threshold_available: function(){
      return this.$store.getters.user
        && Array.isArray(this.$store.getters.user.allowed_options)
        && this.$store.getters.user.allowed_options.indexOf('option1') >= 0
        && this.field_tab === "model";
    },
    bullet_feature_available: function(){
      switch(this.parameters.source_lang + this.parameters.target_lang){
        case "enja":
        case "jaen":
          return true;
      }
      return false;
    }
  },
  methods: {
    mounted: function(initial_parameters=null) {
      if(initial_parameters === null){
        initial_parameters = this.initial_parameters;
      }
      if(initial_parameters){
        this.title = initial_parameters.title;
        this.set_lang_pair(initial_parameters);
        if(initial_parameters.model){
          if(initial_parameters.model_type === 'field'){
            this.field_tab = initial_parameters.model_type;
            this.selected_field = [
              initial_parameters.model
            ];
          }else if(this.$store.getters.domain === "t-3mt"){
            // initial_parameters.model_type === 'model'
            // モデル名取得
            this.field_tab = initial_parameters.model_type;
            this.get_any_names(
              "model",
              "mid",
              [initial_parameters.model],
              "selected_model",
              ["name", "source_lang", "target_lang", "engine"]
            )
              .then(() => {
                if(this.$refs.model_select){
                  this.$refs.model_select.search_mid = initial_parameters.model;
                }
              });
          }
        }
        if(this.$store.getters.domain === "t-3mt"){
          if(initial_parameters.corpuses){
            this.get_any_names(
              "corpus",
              "cid",
              initial_parameters.corpuses,
              "selected_corpuses",
              ["name"],
              true
            )
              .then(() => {
                if(this.$refs.corpuses_select){
                  this.$refs.corpuses_select.get_data("corpus", []);
                }
              });
          }
          this.parameters.term_case_sensitive = initial_parameters.term_case_sensitive;
          if(initial_parameters.terms){
            this.get_any_names(
              "term",
              "yid",
              initial_parameters.terms,
              "selected_terms",
              ["name"],
              true
            )
              .then(() => {
                if(this.$refs.terms_select){
                  this.$refs.terms_select.get_data("term", []);
                }
              });
          }
        }
        if("detail" in initial_parameters){
          if("tag_option" in initial_parameters.detail){
            for(var key of ["tag_type"]){
              if(key in initial_parameters.detail.tag_option){
                this.parameters.detail.tag_option[key] = initial_parameters.detail.tag_option[key];
              }
            }
          }
          if("style_option_ja" in initial_parameters.detail){
            for(var key of ["character_style", "parenthesis_style", "sentence_style"]){
              if(key in initial_parameters.detail.style_option_ja){
                this.parameters.detail.style_option_ja[key] = initial_parameters.detail.style_option_ja[key];
              }
            }
          }
          if("score_threshold" in initial_parameters.detail){
            for(var key of ["custom_model"]){
              if(key in initial_parameters.detail.score_threshold){
                this.parameters.detail.score_threshold[key] = initial_parameters.detail.score_threshold[key];
              }
            }
          }
          if("bullet_option" in initial_parameters.detail){
            for(var key of ["bullet_feature"]){
              if(key in initial_parameters.detail.bullet_option){
                this.parameters.detail.bullet_option[key] = initial_parameters.detail.bullet_option[key];
              }
            }
          }
        }
      }
    },
    make_title: function(panel_name){
      if(panel_name === "title" && this.parameters.title){
        return this.parameters.title;
      }
      var result = "";
      switch(this.field_tab){
        case "field":
          if(this.selected_field.length > 0
            && this.field_property(this.selected_field[0], 'available')){
            result = this.$i18n.t("message.common.general")
              + ": "
              + this.field_property(this.selected_field[0], "name") + "(" + this.selected_field[0] + ")";
          }else{
            result = "(" + this.$i18n.t("message.common.select_text") + ")";
          }
          break;
        case "model":
          if(this.selected_model.length > 0){
            result = this.$i18n.t("message.common.model")
              + ": "
              + this.selected_model[0].name.replace(/\([A-Z]\d{5,8}\)/g, "") + "(" + this.selected_model[0].mid + ")";
          }else{
            result = "(" + this.$i18n.t("message.common.select_text") + ")";
          }
          break;
      }
      return result;
    },
    get_any_names: function(type, id_name, id_list, return_val, columns=["name"], with_priority=false){
      return new Promise((resolve, reject) => {
        this.$http.get(this.$store.getters.api_endpoint + "/" + type)
          .then(function(response){
            if(response && "data" in response){
              if(this.$store.getters.debug){
                console.log("response.data:" + JSON.stringify(response.data));
              }
              var selected_results = [];
              var priority = 1;
              for(var id of id_list){
                for(var d of response.data){
                  if(id === d[id_name]){
                    var selected_result = {};
                    selected_result[id_name] = d[id_name];
                    for(var c of columns){
                      if(c in d){
                        selected_result[c] = d[c];
                      }
                    }
                    if(with_priority){
                      selected_result.priority = priority++;
                    }
                    selected_results.push(selected_result);
                    break;
                  }
                }
              }
              this[return_val] = selected_results;
              return resolve(true);
            }
          }.bind(this))
          .catch( error => {
            if(this.http_error(error)){
              this.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
            }
            return resolve(false);
          });
      });
    },
    set_lang_pair: function(lang_pair){
      if('translatable' in this.$store.getters.lang_pairs
        && lang_pair.source_lang in this.$store.getters.lang_pairs['translatable']){
        this.parameters.source_lang = lang_pair.source_lang;
        if(this.$store.getters.lang_pairs['translatable'][this.parameters.source_lang].indexOf(lang_pair.target_lang) !== -1){
          this.parameters.target_lang = lang_pair.target_lang;
        }else if(this.$store.getters.lang_pairs['translatable'][this.parameters.source_lang].length > 0){
          this.parameters.target_lang = this.$store.getters.lang_pairs['translatable'][this.parameters.source_lang][0];
        }else{
          this.parameters.target_lang = "";
        }
      }
    },
    update_lang_pair: function(event){
      this.lang_pair = event;
      this.reset_field_tab();
      // corpus
      this.selected_corpuses = [];
      if(this.$refs.corpuses_select){
        this.$refs.corpuses_select.get_data("corpus", []);
      }
      // term
      this.parameters.term_case_sensitive = false;
      this.selected_terms = [];
      if(this.$refs.terms_select){
        this.$refs.terms_select.get_data("term", []);
      }
      // detail
      this.parameters.detail = {
        tag_option: {
          tag_type: "tag_type1",
        },
        style_option_ja: {
          character_style: "no_spec",
          parenthesis_style: "no_spec",
          sentence_style: "no_spec"
        },
        score_threshold: {
          custom_model: 0
        },
        bullet_option: {
          bullet_feature: true
        }
      };
      this.$emit('update_lang_pair', event);
    },
    array_equal: function(a, b){
      if (!Array.isArray(a))    return false;
      if (!Array.isArray(b))    return false;
      if (a.length != b.length) return false;
      for (var i = 0, n = a.length; i < n; ++i) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    },
    clear: function(){
      this.field_tab = 'field';
      this.update_lang_pair({
        source_lang: "en",
        target_lang: "ja"
      });
    },
    reset_field_tab: function(){
      // field
      var lang = this.$i18n.locale;
      if(!this.$store.getters.fields.translatable){
        return;
      }
      if(!this.$store.getters.fields.translatable[lang]){
        lang = "en";
      }
      var lang_pair = this.parameters.source_lang + "_" + this.parameters.target_lang;
      var lid_data = this.$store.getters.fields.translatable[lang][lang_pair];
      // 分野が1つしかないものは自動で選択されるようにする
      if(Object.keys(lid_data).length === 2){
        for(var lid in lid_data){
          if(lid !== "root"){
            this.selected_field = [
              lid
            ];
          }
        }
      }else{
        this.selected_field = [];
      }
      // model
      this.selected_model = [];
      if(this.$refs.model_select){
        this.$refs.model_select.search_mid = "";
      }
    },
  },
  watch: {
    registable: {
      handler: function (val, oldVal) {
        this.$emit("update_registable", val);
      }
    },
    changable: {
      handler: function (val, oldVal) {
        this.$emit("update_changable", val);
      }
    },
  }
}
</script>
<style scoped>
.accordion{
  border-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.v-expansion-panel::before{
  box-shadow: none;
}
</style>
